;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import fetchAPI from '@/lib/fetch-api';
import type { UserRestriction } from '@/types/restriction';

/**
 * Fetches the authenticated user's current compliance restriction type.
 * Returns null on missing data; callers treat null as not_restricted (fail-open).
 * @throws {Error} If the API request fails
 */
export async function getOwnUserRestriction(): Promise<UserRestriction | null> {
  const response = await fetchAPI<UserRestriction | null>('/kyc-verification/restriction', {
    method: 'GET',
  });

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(response.error || response.message || 'Failed to get user restriction');
  }

  return response.data ?? null;
}
